var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdminProfileSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di_101_1143)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22.8438,
    cy: 20.8599,
    r: 20,
    fill: "url(#paint0_linear_101_1143)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.8438,
    cy: 20.8599,
    r: 20,
    fill: "url(#paint1_linear_101_1143)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.8438,
    cy: 20.8599,
    r: 17.5,
    stroke: "url(#paint2_linear_101_1143)",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.8438,
    cy: 20.8599,
    r: 17.5,
    stroke: "url(#paint3_linear_101_1143)",
    strokeWidth: 5
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5619 11.8555C19.4381 11.8555 17.7028 13.5908 17.7028 15.7145C17.7028 17.8383 19.4381 19.5736 21.5619 19.5736C23.6857 19.5736 25.421 17.8383 25.421 15.7145C25.421 13.5908 23.6857 11.8555 21.5619 11.8555ZM21.5619 13.1418C22.9904 13.1418 24.1346 14.2867 24.1346 15.7145C24.1346 17.143 22.9904 18.2873 21.5619 18.2873C20.1334 18.2873 18.9892 17.143 18.9892 15.7145C18.9892 14.2867 20.1334 13.1418 21.5619 13.1418ZM19.6324 20.86C16.4364 20.86 13.8438 23.4526 13.8438 26.6486V27.9349C13.8438 28.1055 13.9115 28.2691 14.0321 28.3897C14.1528 28.5104 14.3163 28.5781 14.4869 28.5781H21.4641C21.6347 28.5781 21.7983 28.5104 21.9189 28.3897C22.0395 28.2691 22.1073 28.1055 22.1073 27.9349C22.1073 27.7644 22.0395 27.6008 21.9189 27.4801C21.7983 27.3595 21.6347 27.2918 21.4641 27.2918H15.1301V26.6486C15.1301 24.1434 17.1272 22.1463 19.6324 22.1463H22.2154C22.3859 22.1463 22.5495 22.0786 22.6702 21.9579C22.7908 21.8373 22.8585 21.6737 22.8585 21.5031C22.8585 21.3326 22.7908 21.169 22.6702 21.0484C22.5495 20.9277 22.3859 20.86 22.2154 20.86H19.6324ZM27.3421 20.86C27.2575 20.8609 27.1738 20.8785 27.096 20.9118C27.0181 20.9451 26.9476 20.9934 26.8885 21.054C26.8293 21.1146 26.7827 21.1862 26.7513 21.2648C26.7199 21.3435 26.7043 21.4275 26.7054 21.5122V22.2106C26.3024 22.2946 25.9193 22.4556 25.5773 22.6847L25.0833 22.1907C24.9315 22.0351 24.7598 21.9759 24.5971 21.9849C24.1102 22.0106 23.7063 22.6454 24.1738 23.1002L24.6697 23.5967C24.4418 23.9388 24.282 24.3216 24.1989 24.7242H23.5004C22.6309 24.712 22.6309 26.0234 23.5004 26.0105H24.2015C24.2851 26.4164 24.4491 26.7939 24.671 27.129L24.1713 27.6288C23.5474 28.2353 24.4749 29.1621 25.0807 28.5382L25.5798 28.0398C25.9213 28.2679 26.3034 28.4282 26.7054 28.5119V29.2116C26.6925 30.0812 28.004 30.0812 27.9918 29.2116V28.5138C28.3932 28.4304 28.7749 28.2705 29.116 28.043L29.6177 28.5447C29.6767 28.6075 29.7476 28.6579 29.8264 28.6928C29.9052 28.7277 29.9903 28.7464 30.0764 28.7478C30.1626 28.7492 30.2482 28.7333 30.3281 28.701C30.408 28.6686 30.4805 28.6206 30.5415 28.5597C30.6025 28.4988 30.6506 28.4262 30.6829 28.3463C30.7153 28.2665 30.7313 28.1809 30.73 28.0947C30.7286 28.0086 30.71 27.9235 30.6752 27.8447C30.6403 27.7659 30.59 27.6949 30.5272 27.6359L30.0274 27.1355C30.2553 26.7946 30.4156 26.4132 30.4995 26.0118H31.2006C31.3712 26.0118 31.5347 25.9441 31.6554 25.8235C31.776 25.7028 31.8438 25.5392 31.8438 25.3687C31.8438 25.1981 31.776 25.0345 31.6554 24.9139C31.5347 24.7932 31.3712 24.7255 31.2006 24.7255H30.5021C30.4191 24.3202 30.2583 23.935 30.0287 23.5909L30.5246 23.095C30.5864 23.0353 30.6355 22.9637 30.669 22.8846C30.7026 22.8055 30.7199 22.7204 30.7199 22.6345C30.7199 22.5486 30.7026 22.4635 30.669 22.3844C30.6355 22.3053 30.5864 22.2337 30.5246 22.174C30.4025 22.055 30.2384 21.9891 30.0679 21.9907C29.898 21.9936 29.7361 22.0637 29.6177 22.1856L29.1205 22.6827C28.7787 22.4544 28.3961 22.2942 27.9937 22.2106V21.5122C27.9951 21.4263 27.9792 21.3411 27.9471 21.2615C27.915 21.182 27.8672 21.1096 27.8067 21.0488C27.7461 20.988 27.6739 20.94 27.5945 20.9075C27.515 20.8751 27.4299 20.8589 27.3441 20.86H27.3421ZM27.3505 23.4327C28.4233 23.4327 29.28 24.2888 29.28 25.3622C29.28 26.435 28.4233 27.2918 27.3505 27.2918C26.277 27.2918 25.421 26.435 25.421 25.3622C25.421 24.2888 26.277 23.4327 27.3505 23.4327Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_101_1143",
    x: 0.847312,
    y: 0.859863,
    width: 43.9929,
    height: 43.9929,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.99644
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.998219
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_101_1143"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_101_1143",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.66667
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.33333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_101_1143"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_101_1143",
    x1: 38.7548,
    y1: 35.0796,
    x2: 26.6622,
    y2: 0.188037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#011789"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.590159,
    stopColor: "#1A23FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A2FFE9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_101_1143",
    x1: 5.10198,
    y1: 38.6016,
    x2: 40.5855,
    y2: 3.11809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.11
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.21
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_101_1143",
    x1: 24.4598,
    y1: 40.8599,
    x2: 42.8267,
    y2: 21.5669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C95FF",
    stopOpacity: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C8FED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_101_1143",
    x1: 0.84375,
    y1: 3.71701,
    x2: 29.7595,
    y2: 47.8793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminProfileSettings);
export default __webpack_public_path__ + "static/media/admin_profileSettings.c665de3a8ae9e02f8f07137abfacfa16.svg";
export { ForwardRef as ReactComponent };